<section class="project-risks-modal">
  <header class="project-risks-modal__header">
    <div class="project-risks-modal__header-main">
      <span class="project-risks-modal__eyebrow">Riesgos del proyecto</span>
      <h2>{{ projectTitle }}</h2>
    </div>

    <div class="project-risks-modal__header-actions">
      <label class="project-risks-modal__search">
        <mat-icon>search</mat-icon>
        <input
          type="text"
          [placeholder]="searchPlaceholder"
          [(ngModel)]="searchTerm"
        />
      </label>

      <label class="project-risks-modal__filter">
        <mat-icon>filter_list</mat-icon>
        <select [(ngModel)]="selectedFilter" aria-label="Filtrar riesgos">
          <option *ngFor="let option of filterOptions" [ngValue]="option">{{ option }}</option>
        </select>
      </label>
    </div>

    <button
      type="button"
      mat-icon-button
      class="project-risks-modal__close"
      (click)="close()"
      aria-label="Cerrar modal de riesgos"
    >
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <section class="project-risks-modal__hero">
    <article class="project-risks-modal__summary-card project-risks-modal__summary-card--exposicion">
      <div class="project-risks-modal__summary-meta">
        <div class="project-risks-modal__summary-meta-item">
          <span class="project-risks-modal__summary-meta-label">Cliente</span>
          <strong>{{ projectClient }}</strong>
        </div>
        <div class="project-risks-modal__summary-meta-item">
          <span class="project-risks-modal__summary-meta-label">Líder</span>
          <strong>{{ projectLeader }}</strong>
        </div>
      </div>
    </article>

    <div class="project-risks-modal__summary-stack">
      <article class="project-risks-modal__summary-card project-risks-modal__summary-card--mitigado">
        <span class="project-risks-modal__summary-label">Riesgos mitigados</span>
        <div class="project-risks-modal__summary-body">
          <strong>{{ riesgosMitigados }}</strong>
          <span class="project-risks-modal__summary-icon project-risks-modal__summary-icon--mitigado">
            <mat-icon>verified</mat-icon>
          </span>
        </div>
      </article>

      <article class="project-risks-modal__summary-card project-risks-modal__summary-card--abierto">
        <span class="project-risks-modal__summary-label">Riesgos abiertos</span>
        <div class="project-risks-modal__summary-body">
          <strong>{{ riesgosAbiertos }}</strong>
          <span class="project-risks-modal__summary-icon project-risks-modal__summary-icon--abierto">
            <mat-icon>warning_amber</mat-icon>
          </span>
        </div>
      </article>
    </div>

    <article class="project-risks-modal__summary-card project-risks-modal__summary-card--distribution">
      <span class="project-risks-modal__summary-label">Distribución de severidad</span>
      <div class="project-risks-modal__severity-chart">
        <div class="project-risks-modal__severity-bars">
          <div class="project-risks-modal__severity-bar-item" *ngFor="let item of severityChartItems">
            <span class="project-risks-modal__severity-bar-label">{{ item.shortLabel }}</span>
            <div class="project-risks-modal__severity-bar-track">
              <span
                class="project-risks-modal__severity-bar"
                [style.width.%]="item.percent"
                [style.background]="item.color"
                [attr.aria-label]="item.label + ' ' + item.percent + '%'"
              ></span>
            </div>
            <span class="project-risks-modal__severity-bar-count">{{ item.count }}</span>
          </div>
        </div>
      </div>
    </article>
  </section>

  <section class="project-risks-modal__table-card">
    <div class="project-risks-modal__table-head">
      <span>Riesgo</span>
      <span>Descripción</span>
      <span>Evaluación</span>
      <span>Plan de mitigación</span>
    </div>

    <div class="project-risks-modal__cards" *ngIf="!isLoading && displayedRiesgos.length > 0; else riesgosEmpty">
      <article class="risk-row" *ngFor="let riesgo of displayedRiesgos">
        <div class="risk-row__info">
          <div class="risk-row__meta">
            <strong class="risk-row__folio">R-{{ riesgo.id }}</strong>
            <span class="risk-row__date">{{ riesgo.fecha }}</span>
          </div>

          <div class="risk-row__owner-block">
            <span class="risk-row__owner">{{ getResponsableInitials(riesgo.responsable) }}</span>
            <div class="risk-row__owner-copy">
              <strong>{{ riesgo.responsable }}</strong>
              <span>Responsable</span>
            </div>
          </div>
        </div>

        <div class="risk-row__description">
          <strong>{{ riesgo.descripcion }}</strong>
          <p>{{ riesgo.detalle }}</p>
        </div>

        <div class="risk-row__signals">
          <div class="risk-row__severity-line">
            <span class="risk-row__severity-label">Severidad:</span>
            <span class="risk-row__severity-dot" [style.background]="riesgo.severidadColor"></span>
            <span class="risk-row__severity-value" [ngStyle]="getSeverityStyle(riesgo.severidadColor)">
              {{ riesgo.severidad }}
            </span>
          </div>

          <div class="risk-row__pair">
            <span [class]="getImpactClass(riesgo.probabilidad)">P: {{ riesgo.probabilidad }}</span>
            <span [class]="getImpactClass(riesgo.impacto)">I: {{ riesgo.impacto }}</span>
          </div>
        </div>

        <div class="risk-row__plan">
          <div class="risk-row__plan-copy">
            <span class="risk-row__plan-label">Estrategia</span>
            <strong>{{ riesgo.estrategia }}</strong>
            <p class="risk-row__follow-up">{{ riesgo.accionesSeguir }}</p>
            <button
              type="button"
              class="risk-row__periodicity risk-row__periodicity-link"
              (click)="openRiskFollowUp(riesgo)"
            >
              Seguimientos:

            </button>
            <span class="risk-row__periodicity">
            <mat-icon>schedule</mat-icon>
              {{ riesgo.periodicidad }}
            </span>
          </div>

          <div class="risk-row__status-wrap">
            <span [class]="getStatusClass(riesgo.estado)">{{ riesgo.estado }}</span>
          </div>
        </div>
      </article>
    </div>

    <ng-template #riesgosEmpty>
      <div class="project-risks-modal__empty">
        <mat-icon>{{ isLoading ? "hourglass_top" : loadError ? "error_outline" : "inventory_2" }}</mat-icon>
        <strong>
          {{
            isLoading
              ? "Cargando riesgos..."
              : loadError
                ? "No fue posible consultar los riesgos"
                : "No hay riesgos para mostrar"
          }}
        </strong>
        <span>
          {{
            isLoading
              ? "Espera un momento mientras obtenemos la información del proyecto."
              : loadError
                ? "Intenta nuevamente más tarde o valida la disponibilidad del servicio."
                : "Ajusta la búsqueda o el filtro para ver otros registros."
          }}
        </span>
      </div>
    </ng-template>
  </section>
</section>
